import React, { FC } from 'react';
import Rate from '../../../../../presentational/financeElements/rate/Rate';
import { RateTypes } from '../../../../../../enum/RateTypes';
import useScrollToSection from '../../../../../../hooks/navigation/useScrollToSection';
import IndicativeNumber from '../../../../../../../common/components/indicativeNumber/IndicativeNumber';
import Translation from '../../../../../../../common/components/translation/Translation';
import useInterestRate from '../../../../../../hooks/useInterestRate';

const ChosenRateContainer: FC = () => {
  const interestRate = useInterestRate();
  const { scrollToDisclaimer } = useScrollToSection();

  return (
    <Rate
      labelId={RateTypes.INTEREST_RATE}
      value={
        <Translation
          values={{ value: interestRate }}
          id="trans__configurator__customise_page_finance_details__pa_label"
        />
      }
      indicativeNumber={
        <IndicativeNumber
          displayNumber={<Translation id="trans__configurator__indicative_numbers__disclaimer_interest_rate" />}
          onClick={scrollToDisclaimer}
        />
      }
    />
  );
};

export default ChosenRateContainer;
